"use strict";
console.log('Soulgood block is loaded....');
